function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.styl0{fill:url(#SVGFILE_1_);}\r\n\t.style1{opacity:0.5;fill:url(#SVGFILE_2_);enable-background:new    ;}\r\n\t.style2{opacity:0.502;fill:#42E8E0;enable-background:new    ;}\r\n\t.style3{opacity:0.7529;fill:#42E8E0;enable-background:new    ;}\r\n\t.style4{fill:#42E8E0;}\r\n\t.style5{fill:#24126A;}\r\n\t.style6{fill:url(#SVGFILE_3_);}\r\n\t.style7{fill:url(#SVGFILE_4_);}\r\n\t.style8{fill:url(#SVGFILE_5_);}\r\n\t.style9{fill:url(#SVGFILE_6_);}\r\n\t.style10{fill:url(#SVGFILE_7_);}\r\n\t.style11{fill:url(#SVGFILE_8_);}\r\n\t.style12{opacity:0.5;fill:url(#SVGFILE_9_);enable-background:new    ;}\r\n\t.style13{opacity:0.5;fill:url(#SVGFILE_10_);enable-background:new    ;}\r\n\t.style14{fill:#515151;}\r\n\t.style15{opacity:0.5;}\r\n\t.style16{fill:url(#SVGFILE_11_);}\r\n\t.style17{fill:#2D2D2D;}\r\n\t.style18{fill:url(#SVGFILE_12_);}\r\n\t.style19{clip-path:url(#SVGFILE_14_);fill:#334659;}\r\n\t.style20{fill:#263649;}\r\n\t.style21{opacity:0.5;fill:url(#SVGFILE_17_);enable-background:new    ;}\r\n\t.style22{opacity:0.5;fill:url(#SVGFILE_18_);enable-background:new    ;}\r\n\t.style23{opacity:0.5;fill:url(#SVGFILE_19_);enable-background:new    ;}\r\n\t.style24{opacity:0.5;fill:url(#SVGFILE_20_);enable-background:new    ;}\r\n\t.style25{opacity:0.5;fill:url(#SVGFILE_21_);enable-background:new    ;}\r\n\t.style26{fill:url(#SVGFILE_22_);}\r\n\t.style27{fill:url(#SVGFILE_23_);}\r\n\t.style28{fill:#FFFFFF;}\r\n\t.style29{fill:#2842A2;}\r\n\t.style30{fill:#ADB1F2;}\r\n\t.style31{fill:#9198DB;}\r\n\t.style32{fill:url(#SVGFILE_24_);}\r\n\t.style33{fill:url(#SVGFILE_25_);}\r\n\t.style34{fill:url(#SVGFILE_26_);}\r\n\t.style35{fill:#453C9E;}\r\n\t.style36{opacity:0.6;fill:#42E8E0;enable-background:new    ;}\r\n\t.style37{fill:#54FCEB;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "styl0",
  d: "M18,0h67c9.9,0,18,8.1,18,18v65c0,9.9-8.1,18-18,18H18c-9.9,0-18-8.1-18-18V18C0,8.1,8.1,0,18,0z"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  className: "style1",
  cx: 52.7,
  cy: 56.3,
  rx: 35.6,
  ry: 20.5
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style2",
  d: "M82.4,40.8v-7.3c-0.2-2.5-1.2-4.9-2.8-7v7.3C81.3,35.9,82.3,38.3,82.4,40.8L82.4,40.8z M78.8,32.7v-7.3 c-0.6-0.7-1.2-1.3-1.9-1.9v7.3C77.6,31.4,78.2,32.1,78.8,32.7L78.8,32.7z M75.6,29.9v-7.3c-0.8-0.6-1.6-1.1-2.5-1.7v7.3 C74.1,28.7,74.9,29.3,75.6,29.9L75.6,29.9z M71.5,29.4V17.8c6.7,3.6,10.9,8.7,10.9,14.3v11.6C82.5,38.1,78.2,33,71.5,29.4 L71.5,29.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style2",
  d: "M49.1,12.6c-4.4,0-8.5,0.4-12.4,1.2v11.6c3.9-0.8,8.1-1.3,12.4-1.2c2.3,0,4.4,0.2,6.6,0.4v-4.4 c0-1.6,1-3.5,2.2-4.3l0.3-0.2c0.5-0.3,1-0.3,1.4-0.1l0,0l5.5,3.1v-3.7C60.4,13.6,54.9,12.7,49.1,12.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style2",
  d: "M14.8,29.5c1.3-5.7,6.9-10.5,14.8-13.6v11.6c-7.9,3-13.4,7.9-14.8,13.6V29.5L14.8,29.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style3",
  d: "M79.6,26.5c1.6,2.2,2.6,4.5,2.8,7v7.3c-0.2-2.5-1.2-4.9-2.8-7V26.5L79.6,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M76.8,23.5c0.7,0.6,1.3,1.2,1.9,1.9v7.3c-0.6-0.7-1.2-1.3-1.9-1.9V23.5L76.8,23.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style3",
  d: "M73.2,20.9c0.9,0.5,1.7,1.1,2.5,1.7v7.3c-0.8-0.6-1.6-1.1-2.5-1.7V20.9L73.2,20.9z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "style5",
  d: "M59.6,65.3c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1C59.2,64.2,59.6,64.7,59.6,65.3z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "style5",
  d: "M69.9,53.6c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1C69.5,52.6,69.9,53,69.9,53.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "style5",
  cx: 71.1,
  cy: 61.6,
  r: 1
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "style5",
  d: "M49.6,59.6c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1s0.5-1,1-1S49.6,59,49.6,59.6z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "style5",
  d: "M56.1,52.6c0,0.6-0.5,1-1,1s-1-0.5-1-1s0.5-1,1-1S56.1,52,56.1,52.6z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "style6",
  d: "M60.1,56.4l-11.5,2.2c0,0-0.1,0-0.1,0v-0.1l-0.5-0.1v0.7l0,0c0,0,0,0,0,0.1c0.1,0.2,0.5,0.4,0.9,0.4 l11.5-2.2L60.1,56.4z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "style7",
  d: "M69.7,52.5l-0.3,0.3c-0.3-0.1-0.8-0.1-1.1,0.1l-8.2,3.5l1.1,0.7l8.2-3.6c0.2-0.1,0.3-0.2,0.3-0.4l0,0 L69.7,52.5L69.7,52.5z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "style8",
  d: "M55.8,51.7c-0.2-0.2-0.7-0.3-1.1-0.2l0,0c0,0-0.1,0-0.1,0c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.2-0.2 v0.7l0,0c0,0.1,0,0.1,0.1,0.2l5.3,4.8l1.4-0.4L55.8,51.7z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "style9",
  d: "M71.9,60.5l-0.2,0.1l-0.1,0.2c0,0-0.1,0-0.1,0L61,56.5l-0.7,0.8l10.4,4.2c0.4,0.1,0.9,0,1.1-0.2l0,0 c0.1-0.1,0.1-0.1,0.1-0.2l0,0V60.5z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "style10",
  d: "M59.6,56.9l-1.7,7.3l-0.1-0.1v0.7l0,0c0,0.2,0.3,0.4,0.7,0.4c0.4,0,0.9-0.1,0.9-0.4l1.8-7.8L59.6,56.9z "
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "style11",
  d: "M71.4,60.1l-9.6-3.9l7.6-3.3c0.3-0.2,0.4-0.5,0.1-0.7l-0.1,0c-0.3-0.2-0.8-0.1-1.1,0l-7.6,3.3L55.8,51 c-0.2-0.2-0.7-0.3-1.1-0.2l0,0c-0.4,0.1-0.5,0.4-0.3,0.6l4.9,4.5L48.6,58c-0.4,0-0.8,0.3-0.7,0.5c0.1,0.2,0.5,0.4,0.9,0.4 l10.6-2.1l-1.7,7.2c-0.1,0.2,0.2,0.5,0.7,0.5c0.4,0,0.9-0.1,0.9-0.4l1.7-7.2l9.6,3.9c0.4,0.1,0.9,0,1.1-0.2 C72,60.5,71.8,60.2,71.4,60.1z M60.8,56.2l-0.2,0.2l-0.4,0l-0.1-0.2l0.3-0.1L60.8,56.2z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "style5",
  d: "M60.5,56.8L60.5,56.8c-0.4,0-0.8-0.4-0.8-0.8v-9.7h1.7V56C61.3,56.4,60.9,56.8,60.5,56.8z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "style12",
  d: "M47.6,38.8l-0.2-0.1c-0.7-0.4-0.6-1,0.2-1.5l5.3-3.1c0.8-0.4,1.9-0.5,2.5-0.1l0.2,0.1 c0.7,0.4,0.6,1-0.2,1.5l-5.3,3.1C49.3,39.1,48.2,39.1,47.6,38.8z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "style13",
  d: "M56,34.7L56,34.7c0-0.2-0.2-0.4-0.4-0.6L55.4,34c-0.7-0.4-1.8-0.3-2.5,0.1l-5.3,3.1 C47.2,37.4,47,37.7,47,38l0,0v0.9l0,0c0,0.2,0.1,0.5,0.4,0.7l0.2,0.1c0.7,0.4,1.8,0.3,2.5-0.1l5.3-3.1c0.4-0.2,0.6-0.5,0.6-0.8 l0,0V34.7z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "style14",
  d: "M58.8,43l-11.1,6.4c-0.5,0.3-1,0-1-0.8l0,0c0-0.7,0.4-1.6,1-1.9l12.7-7.3V40C60.4,41.1,59.7,42.5,58.8,43 z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "style16",
  d: "M70.8,22l-2.3,25.6l-3.7,3.2l-6.5,5L47,49.4l8-5.4l3.5-2.9v-0.7l-3,1.7V20.3c0-1.6,1-3.5,2.2-4.3 l0.3-0.2c0.5-0.3,1-0.3,1.4-0.1l0,0l5.5,3.1L70.8,22z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "style17",
  d: "M51.3,51.9c0,0-0.3-0.8,0.3-1.4c0.6-0.6,3.7-1.9,3.9-2.1c0.2-0.1,1.3-1,1.3-1l0.3-0.8c0,0-6.3,0.6-6.4,0.7 c-0.1,0.1-3,2.7-2.9,2.8c0.1,0.1,2,0.6,2,0.6l0.4,0.5L51.3,51.9z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "style18",
  d: "M69.4,22.2L69,22.4c-1.2,0.7-2.2,2.6-2.2,4.3v21.9l-7.9,4.6c-0.5,0.3-1,1.2-1,1.9l0,0c0,0.7,0.4,1.1,1,0.8 L70,49.4c0.9-0.5,1.6-1.9,1.6-3.1v-0.5V23.9C71.6,22.2,70.6,21.5,69.4,22.2z"
});

var _ref24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGFILE_13_",
  d: "M62.8,47.5l-0.2-0.1c-0.7-0.4-0.6-1,0.2-1.5l5.3-3.1c0.8-0.4,1.9-0.5,2.5-0.1l0.2,0.1 c0.7,0.4,0.6,1-0.2,1.5l-5.3,3.1C64.5,47.8,63.4,47.9,62.8,47.5z"
}));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "style19",
  d: "M68.4,30.2c-0.3-0.5-0.4-0.1-0.9,0.3c-0.5,0.5-1.3,1.4-1.6,2.5c-0.7,2-0.4,6.9-0.2,7.6c0,0-6.2,1-6.7,1 c-0.4,0,0.5,3.1,0.5,3.1s9.9-0.3,10.2-0.5c0.2-0.2,0.3-2.7,0.3-4.2C70,38.5,70,32.7,68.4,30.2z"
});

var _ref26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGFILE_15_",
  d: "M62.8,47.5l-0.2-0.1c-0.7-0.4-0.6-1,0.2-1.5l5.3-3.1c0.8-0.4,1.9-0.5,2.5-0.1l0.2,0.1 c0.7,0.4,0.6,1-0.2,1.5l-5.3,3.1C64.5,47.8,63.4,47.9,62.8,47.5z"
}));

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "style20",
  d: "M59.6,44.5c0,0,9.9-0.3,10.2-0.5c0.2-0.2,0.3-2.7,0.3-4.2c0-1,0-5.1-0.9-8c0.7,2.4,0.3,11,0,11.4 c-0.3,0.4-9.8,0.7-9.8,0.7l0,0C59.5,44.3,59.6,44.5,59.6,44.5z"
});

var _ref28 = /*#__PURE__*/React.createElement("polygon", {
  className: "style21",
  points: "52.3,60.9 19.9,42.2 37.4,32.2 69.7,50.9  "
});

var _ref29 = /*#__PURE__*/React.createElement("polygon", {
  className: "style22",
  points: "19.9,40.6 19.9,42.2 52.3,60.9 69.7,50.9 69.7,49.3 52.3,59.4  "
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  className: "style23",
  points: "52.3,59.4 19.9,40.6 37.4,30.6 69.7,49.3  "
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "style24",
  d: "M62.8,47.5l-0.2-0.1c-0.7-0.4-0.6-1,0.2-1.5l5.3-3.1c0.8-0.4,1.9-0.5,2.5-0.1l0.2,0.1 c0.7,0.4,0.6,1-0.2,1.5l-5.3,3.1C64.5,47.8,63.4,47.9,62.8,47.5z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "style25",
  d: "M71.2,43.4L71.2,43.4c0-0.2-0.2-0.4-0.4-0.6l-0.2-0.1c-0.7-0.4-1.8-0.3-2.5,0.1l-5.3,3.1 c-0.4,0.2-0.6,0.5-0.6,0.8l0,0v0.9l0,0c0,0.2,0.1,0.5,0.4,0.7l0.2,0.1c0.7,0.4,1.8,0.3,2.5-0.1l5.3-3.1 c0.4-0.2,0.6-0.5,0.6-0.8l0,0V43.4z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "style26",
  d: "M31,43.6l0.9,0.4l8.7-5c0.1-0.1,0.4-0.1,0.5,0l14.9,8.6c0.1-0.1,0.8-0.4,0.8-0.4l-0.3,0.8l0,0 c0,0,0,0.1-0.1,0.1l-9.1,5.3c-0.1,0.1-0.4,0.1-0.5,0l-15.2-8.8c-0.1,0-0.1-0.1-0.1-0.1l0,0L31,43.6z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "style27",
  d: "M31.1,43.7l15.6,9c0.2,0.1,0.4,0.1,0.6,0l9.3-5.4c0.1-0.1,0.1-0.2,0-0.3L41,38 c-0.2-0.1-0.4-0.1-0.6,0L31,43.4C30.9,43.5,30.9,43.6,31.1,43.7z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M31.1,43.6l15.6,9c0.2,0.1,0.4,0.1,0.6,0l9.3-5.4c0,0,0.1-0.1,0.1-0.1c0,0.1,0,0.1-0.1,0.2l-9.3,5.4 c-0.1,0.1-0.4,0.1-0.6,0l-15.6-9c-0.1-0.1-0.2-0.2-0.1-0.2C31,43.5,31,43.6,31.1,43.6z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "style29",
  d: "M51.4,50.8v-0.2c0,0,0,0,0,0l-0.6,0.3l0,0v0.2c0,0,0,0,0,0L51.4,50.8C51.4,50.8,51.4,50.8,51.4,50.8z "
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "style29",
  d: "M50.5,51.3v-0.2c0,0,0,0,0,0l-0.6,0.3l0,0v0.2c0,0,0,0,0,0L50.5,51.3C50.5,51.3,50.5,51.3,50.5,51.3z "
});

var _ref38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style30",
  d: "M51.4,48.6l-13-7.5c-0.1,0-0.2,0-0.3,0l-4.6,2.7c-0.1,0-0.1,0.1,0,0.2l13,7.5c0.1,0,0.2,0,0.3,0 l4.6-2.7C51.4,48.7,51.4,48.6,51.4,48.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style31",
  d: "M51.4,48.7L51.4,48.7l-13-7.5c-0.1,0-0.2,0-0.3,0l-4.6,2.6l0,0c-0.1,0-0.1-0.1,0-0.2l4.6-2.7 c0.1,0,0.2,0,0.3,0l13,7.5C51.4,48.6,51.4,48.7,51.4,48.7z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "style5",
  points: "37.7,41.7 49.7,48.7 50.3,48.4 38.2,41.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "style5",
  points: "36.5,42.5 47.1,48.6 47.6,48.3 37,42.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "style5",
  points: "35.7,42.9 48.2,50.1 48.7,49.8 36.2,42.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "style5",
  points: "34.9,43.4 47.4,50.6 47.9,50.3 35.4,43.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "style5",
  points: "34.1,43.9 46.6,51 47.1,50.8 34.6,43.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "style5",
  points: "49.7,48.7 50.2,49 50.7,48.7 50.2,48.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "style5",
  points: "46.5,48.2 49,49.7 49.5,49.4 47,47.9  "
})));

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "style32",
  d: "M46.7,45.2l-3.5-2c-0.1-0.1-0.1-0.2,0-0.3l2.4-1.4c0.1-0.1,0.3-0.1,0.5,0l3.5,2 c0.1,0.1,0.1,0.2,0,0.3l-2.4,1.4C47.1,45.3,46.9,45.3,46.7,45.2z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "style31",
  d: "M49.6,43.7l-3.5-2c-0.1-0.1-0.3-0.1-0.5,0L43.3,43c0,0-0.1,0.1-0.1,0.1c0-0.1,0-0.1,0.1-0.2l2.4-1.4 c0.1-0.1,0.3-0.1,0.5,0l3.5,2c0.1,0.1,0.1,0.1,0.1,0.2C49.7,43.7,49.7,43.7,49.6,43.7z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "style33",
  d: "M31,43.3l2-11.7l-0.2-0.1l0.2-0.1l0,0c0,0,0.1,0,0.2,0L49,40.5c0.1,0.1,0.2,0.3,0.2,0.4l-2,11.8 c0,0.1,0,0.1-0.1,0.1l0,0L46.9,53l0-0.2l0,0l-15.7-9.1C31,43.6,31,43.5,31,43.3z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "style34",
  d: "M48.9,40.8l0.3-0.1c0,0.1,0,0.1,0,0.2l-2,11.8c0,0.1,0,0.1-0.1,0.1l0,0L46.9,53l0-0.2l0,0l-0.8-0.4 L48.9,40.8z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "style35",
  d: "M30.9,43.9L46.7,53c0.1,0.1,0.2,0,0.2-0.1l2-11.8c0-0.1-0.1-0.3-0.2-0.4L33,31.5c-0.1-0.1-0.2,0-0.2,0.1 l-2,11.8C30.7,43.6,30.8,43.8,30.9,43.9z"
});

var _ref44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style2",
  d: "M28.9,48.1C21.2,45,15.8,40,14.7,34.4V46c1.1,5.7,6.5,10.6,14.2,13.7V48.1L28.9,48.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style36",
  d: "M64.5,49.3c-4.9,1.5-10.6,2.4-16.7,2.3c-4.2,0-8.2-0.5-11.9-1.3v11.6c3.7,0.8,7.7,1.3,11.9,1.3 c6,0.1,11.7-0.8,16.7-2.3V49.3L64.5,49.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style2",
  d: "M82.4,44.1V32.5c-0.2,5.7-4.6,10.7-11.4,14.2v11.6C77.9,54.8,82.3,49.7,82.4,44.1L82.4,44.1z"
}));

var _ref45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M51.8,20.8c-1.5-0.1-3-0.1-4.5,0c-0.4,0-0.7,0.3-0.6,0.7c0,0.4,0.1,0.8,0.1,1.1c1.9-0.1,3.8,0,5.7,0.1 c0-0.4,0-0.8,0-1.2C52.5,21.1,52.2,20.8,51.8,20.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M55.6,21.1c-1.3-1.5-2.6-3-4.1-4.3c0.3-0.3,0.6-0.5,0.9-0.8c0.1,0.1,0.3,0.1,0.5,0c0.1-0.1,0.1-0.3,0-0.5 c-0.6-0.5-1.2-1.1-1.9-1.6c-0.1-0.1-0.4-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.4l0,0c-0.8,0.8-1.6,1.5-2.3,2.2l0,0 c-0.1-0.1-0.4-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.4c0.7,0.5,1.3,1,1.9,1.5c0.1,0.1,0.3,0.1,0.5,0c0.1-0.1,0.1-0.3,0-0.4l0,0 c0.3-0.3,0.5-0.5,0.8-0.8c1.5,1.3,2.8,2.7,4.1,4.3c0.1,0.2,0.4,0.2,0.6,0.1C55.7,21.6,55.7,21.3,55.6,21.1z"
})));

var _ref46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_15_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_18_",
  className: "style4",
  d: "M24.4,21c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.1c-0.2,0.7-1.1,1.7-0.6,2 c0.2-0.2,0.5-0.3,0.8-0.5C24.8,22.1,24.9,21.3,24.4,21L24.4,21z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_17_",
  className: "style4",
  d: "M23.6,23.5c0.2-0.2,0.5-0.3,0.8-0.5c0,0.2,0,0.3,0,0.5c-0.2,0.2-0.5,0.3-0.7,0.5 C23.6,23.8,23.6,23.7,23.6,23.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_16_",
  className: "style4",
  d: "M23.5,27.2c0,0.1,0.1,0.1,0.2,0c0.1-0.1,0.2-0.3,0.2-0.4c0.1-1,0.2-2,0.3-3 c-0.2,0.2-0.5,0.3-0.7,0.5C23.6,25.3,23.6,26.3,23.5,27.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M18.9,28.6c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.1,0.1,0,0.2-0.1c0.1-0.1,0.2-0.3,0.1-0.4 C19.1,28.4,19,28.5,18.9,28.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M19.8,29.1c-0.1,0.1-0.2,0.3-0.1,0.4c0,0.1,0.1,0.1,0.2-0.1c0.1-0.1,0.2-0.3,0.2-0.4 C20.1,29,19.9,29,19.8,29.1L19.8,29.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M19.1,26.8c0.1-0.1,0.2-0.3,0.3-0.3c0.1,0,0.1,0.1,0,0.2c-0.1,0.1-0.2,0.3-0.3,0.3C19,27.1,19,27,19.1,26.8 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M22.7,23.7c0-1-1.3-0.8-2.6,0.3c-1.4,1.2-2.7,3.3-2.5,5.5c0.2,2.4,1.6,1.8,2.8,0.7c0.8-0.8,1.6-1.9,1.6-2.7 c0-1.2-1,0.3-1-0.6C21,25.9,22.6,25.2,22.7,23.7L22.7,23.7z M19.1,26.4c0.3-0.3,0.7-0.4,0.7-0.2c0.1,0.3-0.2,0.8-0.5,1.1 c-0.3,0.3-0.6,0.4-0.7,0.2C18.5,27.2,18.7,26.7,19.1,26.4L19.1,26.4z M18.6,29.5c-0.1,0-0.2,0-0.2-0.1c0-0.1,0-0.3,0.1-0.5 c0.1-0.2,0.2-0.4,0.4-0.6c0.3-0.3,0.6-0.4,0.7-0.2s-0.1,0.8-0.4,1.1C18.9,29.4,18.8,29.5,18.6,29.5L18.6,29.5z M20,29.7 c-0.3,0.3-0.6,0.4-0.7,0.2c-0.1-0.2,0.1-0.8,0.4-1.1c0.3-0.3,0.6-0.4,0.7-0.2C20.5,28.9,20.3,29.4,20,29.7z M21,25.2 c-0.3,0.3-0.7,0.4-0.8,0.2c-0.1-0.3,0.2-0.8,0.5-1.1c0.3-0.3,0.7-0.4,0.8-0.1C21.6,24.4,21.3,24.9,21,25.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M20.7,24.7c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.1,0.1,0,0.3c-0.1,0.1-0.2,0.2-0.3,0.2 C20.6,25,20.6,24.9,20.7,24.7z"
})));

var _ref47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M79,43.7c-0.2,0.4-0.3,0.8-0.5,1.2c0,0,0.1,0,0.1,0c0.3,0,0.5,0,0.8,0c0,0,0.1,0,0.1,0 c0.2-0.4,0.3-0.8,0.5-1.2C79.7,43.6,79.3,43.7,79,43.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M74.1,51.9c-0.2,0.5-0.5,1.1-0.7,1.7c0.7-0.5,1.3-1,1.9-1.6C74.9,52,74.5,51.9,74.1,51.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M78.3,45.4c0,0-0.1,0-0.1,0c-0.3,0.7-0.8,1.4-1.2,2.2c0,0.1-0.1,0.2-0.1,0.2S76.8,48,76.8,48 c-0.2,0.3-0.3,0.5-0.5,0.8c0,0.1-0.1,0.2-0.2,0.2c-0.5,0.8-1.1,1.6-1.8,2.4c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0 c1.5-2,2.7-4,3.7-6.1C78.6,45.3,78.5,45.3,78.3,45.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M79.2,45.3c-0.1,0-0.2,0-0.3,0c-1,2.1-2.2,4.2-3.7,6.2c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0 c0.6-0.8,1.1-1.6,1.6-2.5c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2c0.1-0.2,0.2-0.4,0.3-0.5c0-0.1,0.1-0.2,0.1-0.2 s0.1-0.2,0.1-0.2C78.6,46.9,78.9,46.1,79.2,45.3C79.3,45.3,79.2,45.3,79.2,45.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M76.5,47.5c0.1-0.5,0-0.8-0.3-0.8c-0.3,0-0.8,0.3-1.3,0.8c-0.1,0.1-0.2,0.2-0.3,0.3c0.3,0,0.5,0.1,0.9,0.1 c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0-0.6-0.1-0.9-0.1c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.1,0.9,0.2,0.9 c0.3,0,0.6-0.1,1-0.4c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2 c0.1-0.2,0.2-0.4,0.3-0.5c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2C76.7,47.5,76.6,47.5,76.5,47.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M80,46.7c-0.3,0-0.8,0.4-1.2,0.9c-0.1,0-0.2,0-0.3,0c0,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.2-0.1,0.2 c-0.1,0.2-0.2,0.4-0.3,0.5c0,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.3,0c-0.1,0.5,0,0.8,0.4,0.8 c0.3,0,0.6-0.2,1-0.5c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.1,0.2-0.2,0.3-0.4c-0.3,0-0.6,0-0.9,0c0-0.1,0-0.2,0.1-0.3 c0.1-0.1,0.2-0.2,0.3-0.4c0.3,0,0.5,0,0.9-0.1c0-0.1,0-0.2,0.1-0.3C80.5,46.9,80.3,46.6,80,46.7z"
})));

var _ref48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style37",
  d: "M50.4,53.7c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.9,1.8c1.1,0,1.9-0.9,1.8-1.8C52.2,54.5,51.4,53.7,50.4,53.7 z M50.6,56.3c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.1,0-0.2c-0.1,0-0.2-0.1-0.3-0.2 c-0.1-0.1,0-0.2,0-0.2c0.1-0.1,0.2,0,0.2,0c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2s-0.1-0.2-0.2-0.2 c-0.3,0-0.5-0.2-0.5-0.5c0-0.2,0.1-0.4,0.3-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2c0,0.1,0,0.1,0,0.2 c0.1,0,0.2,0.1,0.2,0.1s0.1,0.2,0,0.2c-0.1,0.1-0.2,0.1-0.2,0C50.5,55,50.4,55,50.4,55c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2 c0.3,0,0.5,0.2,0.5,0.5C50.9,56,50.8,56.2,50.6,56.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style37",
  d: "M47.1,61.9c0.1,0.1,0.2,0.1,0.3,0c0.3-0.2,0.6-0.5,0.9-0.8c0.2-0.1,0.2-0.3,0.1-0.5 c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.4-0.1c0.8,0,1.6,0,2.4,0c0.4,0,0.8-0.2,1.1-0.4c0,0-0.1,0.1,1.5-1.9 c0.2-0.3,0.2-0.7-0.1-0.9s-0.7-0.1-1,0.1c-0.3,0.3-0.7,0.7-1,1c-0.1-0.1-0.3-0.2-0.5-0.2c-0.7,0-1.3,0-2,0 c-0.3-0.1-0.6-0.2-0.9-0.2c-0.8,0-1.6,0.3-2,1c-0.2,0-0.3,0-0.5,0.1c-0.3,0.2-0.6,0.5-0.9,0.7c-0.1,0.1-0.1,0.2,0,0.2 C45.8,60.6,46.5,61.2,47.1,61.9z"
}));

var _ref49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style4",
  d: "M22.4,47.6c-1.6-1.1-3.3-2.8-4.8-4.3C17.2,43,17,43.1,17,43.4c0,1.1,0,2.1,0,3.2c0,0.3,0.2,0.8,0.5,1.2 c0.5,0.6,1.1,1.1,1.6,1.7c0,0.3-0.1,0.6-0.2,0.8c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.1-0.1-0.1,0s0.1,0.2,0.1,0.3 c0.9,1,1.9,1.9,2.8,2.5c0.1,0,0.1,0,0.1,0c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.4-0.2-0.8-0.2-1.1 c0.5,0.4,1.1,0.8,1.6,1.1c0.3,0.1,0.5,0,0.5-0.3c0-1.1,0-2.1,0-3.2C22.9,48.2,22.7,47.8,22.4,47.6z M19.5,48.1 c0.2-0.5,0.4-1,0.7-1.5c0,0,0.1,0,0.1,0l0,0c0.1,0.1,0.1,0.2,0.1,0.3c-0.2,0.5-0.4,1.1-0.7,1.6c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1 C19.5,48.3,19.4,48.2,19.5,48.1z M18.1,45.7c0.3,0,0.6,0,0.9,0.1c0,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.1 c0,0,0,0.1-0.1,0.1c-0.2,0-0.5,0-0.8,0c0.2,0.5,0.5,0.9,0.7,1.4c0.1,0.1,0.1,0.2,0,0.2c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1 c-0.3-0.5-0.6-1.1-0.9-1.6c0-0.1-0.1-0.1-0.1-0.2C18.1,45.7,18.1,45.7,18.1,45.7z M18.2,47.7L18.2,47.7c-0.1-0.1-0.2-0.2-0.2-0.3 s0.1-0.1,0.1,0c0,0,0,0,0,0c0.1,0.1,0.1,0.2,0.1,0.3C18.4,47.8,18.3,47.8,18.2,47.7z M21.7,50.8c-0.9-0.6-1.9-1.5-2.8-2.4 c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.1,0.1,0c0.9,0.9,1.9,1.8,2.8,2.4c0.1,0.1,0.1,0.2,0.1,0.3C21.8,50.8,21.8,50.8,21.7,50.8z  M21.8,49.2c-0.3,0.1-0.6,0.1-0.9,0.1c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.1-0.1c-0.1-0.1,0-0.2,0-0.2c0.2,0,0.5,0,0.8-0.1 c-0.2-0.4-0.5-0.8-0.8-1.3c0-0.1,0-0.1-0.1-0.2c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0.3,0.5,0.6,1,0.9,1.5 C21.8,49,21.8,49.1,21.8,49.2C21.8,49.1,21.8,49.2,21.8,49.2z"
}));

var _ref50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M46.3,83.2c0-0.2,0-0.5,0.1-0.8l0.8,0.2c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.4,0.1,0.6,0.2,0.8 c0.1,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.2-0.4,0.2-0.9c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.3-0.2-0.5-0.2h-0.3 v-0.8h0.5c0.3,0,0.4-0.2,0.4-0.5c0-0.2-0.3-0.4-0.8-0.4c-0.5,0-0.8-0.3-0.8-0.9h1c0,0.1,0.2,0.3,0.8,0.3c0.5,0.1,0.8,0.4,0.8,1 c0,0.4-0.2,0.7-0.5,0.9c0.4,0.4,0.6,0.8,0.6,1.1c0,0.6-0.1,1.1-0.5,1.4c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.1-1.2-0.4 C46.5,84.3,46.3,83.8,46.3,83.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M50.4,82.8c0-0.5,0.1-0.9,0.2-1.3c0.2-0.4,0.4-0.7,0.7-1c0.6-0.5,1.4-0.8,2.5-0.8v0.8 c-1.2,0.1-2,0.3-2.2,0.7l0.5-0.1c0.3,0,0.6,0.2,0.9,0.5c0.3-0.3,0.6-0.5,1-0.5c0.5,0,0.9,0.1,1.2,0.4c0.3,0.3,0.4,0.8,0.4,1.4 c0,0.8-0.2,1.4-0.7,2.1h-1.2c0.7-0.7,1.1-1.4,1.1-2.1c0-0.4-0.1-0.7-0.2-0.8c-0.2-0.2-0.3-0.3-0.6-0.3c-0.3,0-0.5,0.2-0.5,0.7 v1.2h-0.8v-1.2c0-0.4-0.2-0.7-0.5-0.7c-0.5,0-0.8,0.3-0.8,1.1c0,0.8,0.4,1.5,1.1,2.2h-1.2C50.6,84.3,50.4,83.6,50.4,82.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M56.3,82.3c0-0.9,0.2-1.5,0.5-1.9c0.3-0.4,0.7-0.6,1.1-0.6c0.4,0,0.7,0.2,1,0.6c0.2-0.4,0.5-0.6,1-0.6 c0.4,0,0.8,0.2,1.1,0.6c0.3,0.4,0.5,1,0.5,1.9c0,0.9-0.3,1.8-0.8,2.7h-1.1c0.7-1,1.1-1.9,1.1-2.7c0-0.6-0.1-1.1-0.2-1.3 c-0.1-0.2-0.3-0.4-0.6-0.4c-0.4,0-0.5,0.2-0.5,0.8V83h-0.8v-1.7c0-0.5-0.2-0.8-0.5-0.8c-0.3,0-0.5,0.1-0.6,0.4 c-0.1,0.2-0.2,0.7-0.2,1.3c0,0.9,0.3,1.8,1.1,2.7h-1.1C56.5,84.1,56.3,83.2,56.3,82.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M62.2,81.6c0-0.5,0.1-1,0.4-1.3c0.3-0.3,0.7-0.5,1.2-0.5c0.5,0,0.8,0.1,1.1,0.4c0.3-0.3,0.7-0.4,1-0.4 c0.4,0,0.8,0.1,1.1,0.4c0.3,0.2,0.4,0.6,0.4,1c0,0.6-0.2,1-0.5,1.2c0.2,0.1,0.3,0.3,0.4,0.4c0.1,0.2,0.1,0.3,0.1,0.5 c0,0.6-0.2,1-0.6,1.3c-0.4,0.2-0.9,0.4-1.5,0.4c-0.6,0-1.1-0.1-1.5-0.3c-0.4-0.2-0.6-0.5-0.6-0.8h1c0.1,0.2,0.5,0.4,1.2,0.4 c0.5,0,0.9-0.1,1-0.2s0.3-0.3,0.3-0.7c0-0.4-0.2-0.6-0.4-0.6h-0.4v-0.7h0.4c0.2,0,0.3-0.1,0.3-0.3s0.1-0.4,0.1-0.7s0-0.4-0.1-0.5 c-0.1-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.4,0.1-0.6,0.2c0.1,0.3,0.1,0.6,0.1,0.8c0,0.5-0.2,1-0.5,1.3s-0.7,0.5-1.2,0.5 c-0.5,0-0.9-0.2-1.2-0.5S62.2,82,62.2,81.6z M63,81.6c0,0.4,0.1,0.7,0.2,0.8c0.1,0.2,0.3,0.2,0.6,0.2c0.3,0,0.4-0.1,0.6-0.2 c0.1-0.2,0.2-0.4,0.2-0.8c0-0.4-0.1-0.7-0.2-0.8c-0.1-0.2-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.5,0.2C63.1,80.9,63,81.2,63,81.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M68.2,83.4c0-0.3,0.1-0.5,0.2-0.9l0.8,0.4c-0.1,0.2-0.1,0.4-0.1,0.7s0.1,0.4,0.2,0.5 c0.1,0.1,0.3,0.2,0.5,0.2c0.3,0,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.4,0.2-0.8V81c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.3,0-0.5,0.1-0.5,0.2c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0,0.3,0.1,0.5l-0.7,0.3c-0.2-0.3-0.3-0.5-0.3-0.8c0-0.3,0.1-0.7,0.4-0.9 c0.3-0.3,0.7-0.4,1.1-0.4c0.5,0,0.9,0.1,1.2,0.4c0.3,0.2,0.4,0.5,0.4,0.9v2.3c0,0.6-0.2,1.1-0.5,1.3c-0.3,0.3-0.7,0.4-1.2,0.4 c-0.4,0-0.7-0.1-1.1-0.3C68.4,84.5,68.2,84.1,68.2,83.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M72.3,83.3v-3.5h0.8v3.5c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.6-0.2 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.8-0.3-1c-0.2-0.2-0.3-0.7-0.3-1.4h0.8c0,0.5,0.1,1,0.3,1.2c0.2,0.2,0.3,0.7,0.3,1.2 c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5C72.4,84.2,72.2,83.8,72.3,83.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M76.3,82.2c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7s0.9,0.2,1.2,0.7s0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 s-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C76.4,83.8,76.3,82.9,76.3,82.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M80.3,80.3l0.3-0.7c0.2,0.1,0.3,0.2,0.4,0.2h0.3c0.2,0,0.4,0.1,0.6,0.4c0.2-0.3,0.4-0.4,0.8-0.4 c0.2,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7v2.4c0,0.7-0.1,1.2-0.4,1.5s-0.7,0.4-1.2,0.4c-0.5,0-0.9-0.1-1.2-0.4 c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.2,0.1-0.5,0.2-0.9l0.8,0.3c-0.1,0.2-0.2,0.5-0.2,0.8c0,0.2,0.1,0.3,0.2,0.5 c0.1,0.1,0.3,0.2,0.6,0.2c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.4,0.2-1v-2.4c0-0.2-0.1-0.2-0.3-0.2s-0.3,0.1-0.3,0.2v1.1h-0.8 v-1.1c0-0.1-0.1-0.2-0.2-0.2h-0.4C80.8,80.5,80.5,80.5,80.3,80.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M84.6,81.7c0-0.6,0.2-1.1,0.4-1.4c0.3-0.3,0.7-0.5,1.1-0.5c0.4,0,0.7,0.2,0.9,0.5c0.2-0.3,0.5-0.5,0.9-0.5 s0.7,0.2,0.9,0.5c0.1-0.2,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.1,0.5-0.1c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.8,0.4,1.4 c0,0.4-0.2,1-0.5,1.5h-1.1c0.5-0.6,0.8-1.1,0.8-1.5c0-0.5-0.1-0.8-0.2-0.9c-0.1-0.1-0.3-0.2-0.5-0.2c-0.4,0-0.5,0.3-0.5,0.9v0.9 h-0.8v-0.9c0-0.5-0.2-0.9-0.5-0.9c-0.3,0-0.5,0.3-0.5,0.9v0.9h-0.8v-0.9c0-0.6-0.2-0.9-0.5-0.9c-0.2,0-0.3,0.1-0.5,0.2 c-0.2,0.2-0.2,0.4-0.2,0.9c0,0.8,0.5,1.4,1.4,2c1.1,0,1.9,0.1,2.4,0.3c0.5,0.2,0.8,0.5,0.8,1H89c-0.1-0.3-0.3-0.4-0.7-0.5 c-0.3-0.1-0.8-0.1-1.2-0.1c-0.9,0-1.5,0.1-2,0.2v-0.8l0.5-0.1C84.9,83.2,84.6,82.5,84.6,81.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M92.1,82.2c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7c0.5,0,0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 s-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C92.2,83.8,92.1,82.9,92.1,82.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M22.6,90.6c0-0.9,0.2-1.5,0.5-1.9c0.3-0.4,0.7-0.6,1.1-0.6c0.4,0,0.7,0.2,1,0.6c0.2-0.4,0.5-0.6,1-0.6 c0.4,0,0.8,0.2,1.1,0.6c0.3,0.4,0.5,1,0.5,1.9c0,0.9-0.3,1.8-0.8,2.7h-1.1c0.7-1,1.1-1.9,1.1-2.7c0-0.6-0.1-1.1-0.2-1.3 c-0.1-0.2-0.3-0.4-0.6-0.4c-0.4,0-0.5,0.2-0.5,0.8v1.7h-0.8v-1.7c0-0.5-0.2-0.8-0.5-0.8c-0.3,0-0.5,0.1-0.6,0.4 c-0.1,0.2-0.2,0.7-0.2,1.3c0,0.9,0.3,1.8,1.1,2.7h-1.1C22.9,92.3,22.6,91.4,22.6,90.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M28.5,91.1c0-0.5,0.1-0.9,0.2-1.3c0.2-0.4,0.4-0.7,0.7-1c0.6-0.5,1.4-0.8,2.5-0.8v0.8 c-1.2,0.1-2,0.3-2.2,0.7l0.5-0.1c0.3,0,0.6,0.2,0.9,0.5c0.3-0.3,0.6-0.5,1-0.5c0.5,0,0.9,0.1,1.2,0.4c0.3,0.3,0.4,0.8,0.4,1.4 c0,0.8-0.2,1.4-0.7,2.1h-1.2c0.7-0.7,1.1-1.4,1.1-2.1c0-0.4-0.1-0.7-0.2-0.8c-0.1-0.2-0.3-0.3-0.6-0.3c-0.3,0-0.5,0.2-0.5,0.7 v1.2h-0.8v-1.2c0-0.4-0.2-0.7-0.5-0.7c-0.5,0-0.8,0.3-0.8,1.1c0,0.8,0.4,1.5,1.1,2.2h-1.3C28.8,92.5,28.5,91.8,28.5,91.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M34.4,90.5c0-0.8,0.1-1.3,0.4-1.8c0.3-0.4,0.7-0.7,1.2-0.7c0.5,0,0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C34.5,92.1,34.4,91.2,34.4,90.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M38.4,91.7c0-0.3,0.1-0.5,0.2-0.9l0.8,0.4c-0.1,0.2-0.1,0.4-0.1,0.7s0.1,0.4,0.2,0.5 c0.1,0.1,0.3,0.2,0.5,0.2c0.3,0,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.4,0.2-0.8v-2.3c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.3,0-0.5,0.1-0.5,0.2c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0,0.3,0.1,0.5l-0.7,0.3c-0.2-0.3-0.3-0.5-0.3-0.8c0-0.3,0.1-0.7,0.4-0.9 c0.3-0.3,0.7-0.4,1.1-0.4c0.5,0,0.9,0.1,1.2,0.4c0.3,0.2,0.4,0.5,0.4,0.9v2.3c0,0.6-0.2,1.1-0.5,1.3c-0.3,0.3-0.7,0.4-1.2,0.4 c-0.4,0-0.7-0.1-1.1-0.3C38.6,92.7,38.4,92.3,38.4,91.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M42.4,91.5v-2.3c0-0.4,0.1-0.7,0.4-0.9c0.2-0.2,0.5-0.3,0.8-0.3h1.9v0.8h-1.8c-0.3,0-0.4,0.1-0.4,0.3v1 c0.3-0.2,0.5-0.4,0.8-0.4c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.7,0.4,1.3c0,0.6-0.1,1-0.4,1.3c-0.3,0.3-0.7,0.5-1.1,0.5 c-0.5,0-0.9-0.2-1.2-0.5C42.6,92.4,42.4,92,42.4,91.5z M43.3,91.5c0,0.4,0.1,0.7,0.2,0.8c0.2,0.1,0.4,0.2,0.6,0.2 c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.4,0.2-0.8c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.6,0.2 C43.4,90.9,43.3,91.2,43.3,91.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M46.4,90.8c0-0.9,0.2-1.5,0.6-1.9c0.4-0.3,0.8-0.5,1.1-0.6c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1H49l-0.1,0.2 c0.3,0,0.7,0.2,1.1,0.5c0.4,0.3,0.6,1,0.7,1.9c0,0.8-0.2,1.4-0.5,1.8c-0.4,0.4-0.9,0.7-1.5,0.7c-0.7,0-1.2-0.2-1.5-0.7 C46.6,92.1,46.4,91.5,46.4,90.8z M47.3,90.8c0,0.5,0.1,0.9,0.3,1.3c0.2,0.3,0.5,0.5,0.9,0.5c0.4,0,0.8-0.2,0.9-0.5 c0.2-0.3,0.3-0.7,0.3-1.3c0-0.6-0.1-1-0.3-1.3c-0.2-0.2-0.4-0.4-0.7-0.5l0.1,2.5H48l0-2.5c-0.2,0.1-0.4,0.3-0.6,0.5 C47.4,89.7,47.3,90.2,47.3,90.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M51.4,91.2c0-0.4,0.1-0.8,0.3-1.1l0.8,0.3c-0.1,0.4-0.2,0.7-0.2,0.9c0,0.4,0.1,0.8,0.2,1 c0.1,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.4-0.7-1-0.7-1.7h0.8 c0,0.4,0.2,0.9,0.7,1.4c0.5,0.5,0.7,1.1,0.7,1.9c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.7,0.6-1.2,0.6c-0.5,0-0.9-0.2-1.2-0.6 C51.5,92.3,51.4,91.8,51.4,91.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M55.4,90.5c0-0.8,0.1-1.6,0.4-2.5h0.9c-0.3,0.8-0.4,1.6-0.4,2.4c0,0.6,0.1,1.1,0.3,1.5 c0.2,0.4,0.5,0.6,0.9,0.6c0.4,0,0.7-0.1,0.8-0.3c0.2-0.2,0.2-0.5,0.2-0.8c0-0.4-0.1-0.5-0.3-0.5h-0.8v-0.7H58 c0.2,0,0.3-0.2,0.3-0.5c0-0.1-0.1-0.3-0.3-0.5c-0.2-0.2-0.3-0.5-0.3-1.1h0.8c0,0.3,0.1,0.6,0.4,0.8c0.2,0.2,0.4,0.4,0.4,0.7 c0,0.4-0.1,0.7-0.4,0.8c0.4,0.3,0.5,0.6,0.5,1c0,0.5-0.2,1-0.5,1.4c-0.3,0.4-0.8,0.5-1.4,0.5s-1.1-0.3-1.4-0.8 C55.5,92,55.4,91.3,55.4,90.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M60,90.5c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7c0.5,0,0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7H62c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C60.1,92.1,60,91.2,60,90.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M64.1,90.5c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7s0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7H66c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C64.2,92.1,64.1,91.2,64.1,90.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M68.1,91.5V88h0.8v3.5c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.6-0.2 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.8-0.3-1c-0.2-0.2-0.3-0.7-0.3-1.4h0.8c0,0.5,0.1,1,0.3,1.2c0.2,0.2,0.3,0.7,0.3,1.2 c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5C68.2,92.4,68.1,92,68.1,91.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M74.2,90.8c0-0.9,0.2-1.5,0.6-1.9c0.4-0.3,0.8-0.5,1.1-0.6c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1h0.9l-0.1,0.2 c0.3,0,0.7,0.2,1.1,0.5c0.4,0.3,0.6,1,0.7,1.9c0,0.8-0.2,1.4-0.5,1.8c-0.4,0.4-0.9,0.7-1.5,0.7c-0.7,0-1.2-0.2-1.5-0.7 C74.4,92.1,74.2,91.5,74.2,90.8z M75,90.8c0,0.5,0.1,0.9,0.3,1.3c0.2,0.3,0.5,0.5,0.9,0.5c0.4,0,0.8-0.2,0.9-0.5s0.3-0.7,0.3-1.3 c0-0.6-0.1-1-0.3-1.3c-0.2-0.2-0.4-0.4-0.7-0.5l0.1,2.5h-0.8l0-2.5c-0.2,0.1-0.4,0.3-0.6,0.5C75.1,89.7,75,90.2,75,90.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M79.1,91.7c0-0.3,0.1-0.5,0.2-0.9l0.8,0.4C80,91.4,80,91.7,80,91.9s0.1,0.4,0.2,0.5 c0.1,0.1,0.3,0.2,0.5,0.2c0.3,0,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.4,0.2-0.8v-2.3c0-0.2-0.1-0.3-0.2-0.4s-0.3-0.1-0.5-0.1 c-0.3,0-0.5,0.1-0.5,0.2c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0,0.3,0.1,0.5l-0.7,0.3c-0.2-0.3-0.3-0.5-0.3-0.8c0-0.3,0.1-0.7,0.4-0.9 c0.3-0.3,0.7-0.4,1.1-0.4c0.5,0,0.9,0.1,1.2,0.4c0.3,0.2,0.4,0.5,0.4,0.9v2.3c0,0.6-0.2,1.1-0.5,1.3c-0.3,0.3-0.7,0.4-1.2,0.4 c-0.4,0-0.7-0.1-1.1-0.3C79.3,92.7,79.1,92.3,79.1,91.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M83.2,91.5V88H84v3.5c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.6-0.2 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.8-0.3-1c-0.2-0.2-0.3-0.7-0.3-1.4h0.8c0,0.5,0.1,1,0.3,1.2c0.2,0.2,0.3,0.7,0.3,1.2 c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5C83.3,92.4,83.1,92,83.2,91.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M87.2,90.8c0-0.9,0.2-1.5,0.6-1.9c0.4-0.3,0.8-0.5,1.1-0.6c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1h0.9l-0.1,0.2 c0.3,0,0.7,0.2,1.1,0.5c0.4,0.3,0.6,1,0.7,1.9c0,0.8-0.2,1.4-0.5,1.8c-0.4,0.4-0.9,0.7-1.5,0.7c-0.7,0-1.2-0.2-1.5-0.7 C87.4,92.1,87.2,91.5,87.2,90.8z M88,90.8c0,0.5,0.1,0.9,0.3,1.3c0.2,0.3,0.5,0.5,0.9,0.5c0.4,0,0.8-0.2,0.9-0.5 c0.2-0.3,0.3-0.7,0.3-1.3c0-0.6-0.1-1-0.3-1.3c-0.2-0.2-0.4-0.4-0.7-0.5l0.1,2.5h-0.8l0-2.5c-0.2,0.1-0.4,0.3-0.6,0.5 C88.1,89.7,88,90.2,88,90.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "style28",
  d: "M92.1,90.5c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7c0.5,0,0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C92.2,92.1,92.1,91.2,92.1,90.5z"
})));

var SvgProfSmall = function SvgProfSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 101",
    style: {
      enableBackground: "new 0 0 103 101"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -60.5223,
    y1: -20.0513,
    x2: 50.7446,
    y2: 63.3988,
    gradientTransform: "matrix(0.8333 0 0 -1.1111 55.5738 74.5817)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#26A3D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A2980"
    }
  })), _ref3, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGFILE_2_",
    cx: -2327.9014,
    cy: 675.4982,
    r: 29.0394,
    gradientTransform: "matrix(-0.866 0.5 -0.866 -0.5 -1378.2452 1557.9978)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42E8E0",
      stopOpacity: 0
    }
  })), _ref4, _ref5, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("g", null, _ref9, _ref10, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.9474,
    y1: 46.5433,
    x2: 41.0381,
    y2: 41.9283,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5761D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    style: {
      stopColor: "#5C66D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    style: {
      stopColor: "#6A73DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    style: {
      stopColor: "#8289E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "#A3A7F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEFF"
    }
  })), _ref11, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.0833,
    y1: 48.2298,
    x2: 81.017,
    y2: 48.2298,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5761D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    style: {
      stopColor: "#5C66D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    style: {
      stopColor: "#6A73DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    style: {
      stopColor: "#8289E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "#A3A7F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEFF"
    }
  })), _ref12, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.7272,
    y1: 48.6821,
    x2: 52.8342,
    y2: 53.4117,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5761D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    style: {
      stopColor: "#5C66D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    style: {
      stopColor: "#6A73DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    style: {
      stopColor: "#8289E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "#A3A7F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEFF"
    }
  })), _ref13, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.3429,
    y1: 43.9493,
    x2: 78.5198,
    y2: 43.9493,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5761D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    style: {
      stopColor: "#5C66D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    style: {
      stopColor: "#6A73DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    style: {
      stopColor: "#8289E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "#A3A7F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEFF"
    }
  })), _ref14, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.7995,
    y1: 41.9103,
    x2: 61.2253,
    y2: 41.9103,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5761D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    style: {
      stopColor: "#5C66D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    style: {
      stopColor: "#6A73DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    style: {
      stopColor: "#8289E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "#A3A7F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEFF"
    }
  })), _ref15, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.909,
    y1: 45.2981,
    x2: 82.8655,
    y2: 45.2981,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C0BFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#C5C4F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    style: {
      stopColor: "#D3D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9E9FD"
    }
  })), _ref16), _ref17)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.9508,
    y1: 66.6153,
    x2: 56.0139,
    y2: 66.6153,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#43E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    style: {
      stopColor: "#45D5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    style: {
      stopColor: "#49BDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    style: {
      stopColor: "#4E9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#5472D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5761D7"
    }
  })), _ref18, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.9508,
    y1: 66.169,
    x2: 56.0148,
    y2: 66.169,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#43E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    style: {
      stopColor: "#45D5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    style: {
      stopColor: "#49BDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    style: {
      stopColor: "#4E9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#5472D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5761D7"
    }
  })), _ref19), /*#__PURE__*/React.createElement("g", null, _ref20, /*#__PURE__*/React.createElement("g", {
    className: "style15"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.7301,
    y1: 84.156,
    x2: 54.0053,
    y2: 48.8375,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#43E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    style: {
      stopColor: "#45D5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    style: {
      stopColor: "#49BDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    style: {
      stopColor: "#4E9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#5472D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5761D7"
    }
  })), _ref21)), _ref22, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.9186,
    y1: 64.1103,
    x2: 71.6185,
    y2: 64.1103,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#43E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    style: {
      stopColor: "#45D5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    style: {
      stopColor: "#49BDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    style: {
      stopColor: "#4E9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#5472D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5761D7"
    }
  })), _ref23, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref24, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGFILE_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGFILE_13_",
    style: {
      overflow: "visible"
    }
  })), _ref25), /*#__PURE__*/React.createElement("g", null, _ref26, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGFILE_15_",
    style: {
      overflow: "visible"
    }
  })), _ref27)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9477,
    y1: 56.4698,
    x2: 69.731,
    y2: 56.4698,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#43E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    style: {
      stopColor: "#45D5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    style: {
      stopColor: "#49BDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    style: {
      stopColor: "#4E9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#5472D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5761D7"
    }
  })), _ref28, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9477,
    y1: 52.2297,
    x2: 69.731,
    y2: 52.2297,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#43E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    style: {
      stopColor: "#45D5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    style: {
      stopColor: "#49BDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    style: {
      stopColor: "#4E9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#5472D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5761D7"
    }
  })), _ref29, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9477,
    y1: 58.0148,
    x2: 69.731,
    y2: 58.0148,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#43E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    style: {
      stopColor: "#45D5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    style: {
      stopColor: "#49BDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    style: {
      stopColor: "#4E9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#5472D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5761D7"
    }
  })), _ref30), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.1438,
    y1: 57.8947,
    x2: 71.2069,
    y2: 57.8947,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#43E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    style: {
      stopColor: "#45D5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    style: {
      stopColor: "#49BDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    style: {
      stopColor: "#4E9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#5472D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5761D7"
    }
  })), _ref31, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.1433,
    y1: 57.4483,
    x2: 71.2073,
    y2: 57.4483,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#43E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    style: {
      stopColor: "#45D5DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    style: {
      stopColor: "#49BDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    style: {
      stopColor: "#4E9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#5472D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5761D7"
    }
  })), _ref32)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.6855,
    y1: 56.7445,
    x2: 235.4355,
    y2: 56.7445,
    gradientTransform: "matrix(-1 0 0 -1 266.4042 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5761D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    style: {
      stopColor: "#5C66D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    style: {
      stopColor: "#6A73DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    style: {
      stopColor: "#8289E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "#A3A7F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEFF"
    }
  })), _ref33, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.3416,
    y1: 57.6372,
    x2: 244.118,
    y2: 57.6372,
    gradientTransform: "matrix(-1 0 0 -1 266.4042 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C0BFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#C5C4F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    style: {
      stopColor: "#D3D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9E9FD"
    }
  })), _ref34, _ref35, _ref36, _ref37, _ref38, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.6689,
    y1: 59.6156,
    x2: 223.2679,
    y2: 59.6156,
    gradientTransform: "matrix(-1 0 0 -1 266.4042 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C0BFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#C5C4F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    style: {
      stopColor: "#D3D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9E9FD"
    }
  })), _ref39, _ref40)))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.1979,
    y1: 60.8259,
    x2: 235.4355,
    y2: 60.8259,
    gradientTransform: "matrix(-1 0 0 -1 266.4042 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C0BFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#C5C4F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    style: {
      stopColor: "#D3D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9E9FD"
    }
  })), _ref41, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGFILE_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.185,
    y1: 56.1093,
    x2: 220.3177,
    y2: 56.1093,
    gradientTransform: "matrix(-1 0 0 -1 266.4042 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5761D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1779,
    style: {
      stopColor: "#5C66D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    style: {
      stopColor: "#6A73DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    style: {
      stopColor: "#8289E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    style: {
      stopColor: "#A3A7F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEFF"
    }
  })), _ref42, _ref43)), _ref44), _ref45, _ref46, _ref47, _ref48, _ref49), _ref50));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prof-small.7e6ca97e.svg";
export { ForwardRef as ReactComponent };